import React from "react";
import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { setChonkyDefaults } from "chonky";
import { ChonkyIconFA } from "chonky-icon-fontawesome";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";
import { unstable_ClassNameGenerator as ClassNameGenerator } from "@mui/material/className";
import { TopLoaderProvider } from "./context/TopLoaderContext";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

ClassNameGenerator.configure((componentName) => `REPLACE-${componentName}`);
setChonkyDefaults({ iconComponent: ChonkyIconFA });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <TopLoaderProvider>
          <ToastContainer
            position="bottom-left"
            hideProgressBar
            theme="dark"
            pauseOnFocusLoss={false}
            // style={{ width: "auto", minWidth: "200px" }}
          />
          <App />
        </TopLoaderProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
